module.exports = __webpack_public_path__ + "img/login-bg-6.913f2189.jpg";